import React from 'react';
import './AboutSection.css';
import img from '../assets/stall.png';

export default function AboutSection() {
  return (
    <section className="full-section about-section">
      <div className="fw-inner container about-inner">
        <div className="about-content">
          <h3 className="cats-title">Who Are We</h3>
          <p className="about-text">HPFS Australia is an Australian-based Manufacturing company supplying high-quality instrumentation valves, fittings, and engineered flow control solutions to customers across Australia and international markets. We are a Sister Concern of HP Valves & Fittings India Private Limited, a globally recognized manufacturer with over two decades of experience in precision engineering and flow control systems.</p>
          <p className="about-text"> Through this strategic partnership, HPFS brings together local presence and support in Australia with world-class manufacturing, testing, and certifications. Our focus is on delivering reliable, compliant, and cost-effective solutions that meet international standards while supporting our customers with responsive service, technical expertise, and dependable supply.</p>
        </div>

        <div className="about-image float-image">
          <div className="about-image-inner" style={{ backgroundImage: `url(${img})` }} />
        </div>
      </div>
    </section>
  );
}
